// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"b0a2a200","31":"2eff572b","139":"f10ea47f","149":"212a7bb8","320":"3d44afa2","347":"7ae86733","428":"1ad51d35","571":"f7abde8c","621":"bd1e2c50","744":"6cb53665","757":"a9ff51af","833":"5e63ee97","853":"aa6df0c2"}[chunkId] + ".chunk.js";
};